import {KEYS} from './Constants';

/**
 * @function getData
 * @param key: String
 * @returns string value
 * @description Function returns data retriving from local storage using key
 */
export const getData = async key => {
  let value;
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-undef
    value = localStorage.getItem(key);
  }
  return value;
};

/**
 * @function storeData
 * @param key: String
 * @param value: String
 * @description Function stored data to local storage
 */
export const storeData = async (key, value) => {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-undef
    localStorage.setItem(key, value);
  }
};

/**
 * @function removeData
 * @param key: String
 * @description Function removes data to async storage for given key
 */
export const removeData = async key => {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-undef
    localStorage.removeItem(key);
  }
};

/**
 * @function storeUserProfileData
 * @param value: String
 * @description Function stored user profile data to async storage
 */
export const storeUserProfileData = async value => {
  if (typeof window !== 'undefined') {
    // eslint-disable-next-line no-undef
    localStorage.setItem(KEYS.userInfo, JSON.stringify(value));
  }
};

/**
 * @function getUserProfileData
 * @param key: String
 * @returns string value
 * @description Function returns User Profile data retriving from async storage using key
 */
export const getUserProfileData = async () => {
  try {
    // eslint-disable-next-line no-undef
    const data = localStorage.getItem(KEYS.userInfo);
    const value = JSON.parse(data);
    return value;
  } catch (e) {
    // saving error
    //put in analytics for example
  }
};

/**
 * @function getUserPhoneNumber
 * @param key: String
 * @returns string value
 * @description Function returns User phone number retriving from async storage using key
 */
export const getUserPhoneNumber = async () => {
  try {
    // eslint-disable-next-line no-undef
    const data = localStorage.getItem(KEYS.userInfo);
    const value = JSON.parse(data);
    return value.phone.replace(/-/gi, '');
  } catch (e) {
    // saving error
    //put in analytics for example
  }
};

/**
 * @function getPatientCondition
 * @param key: String
 * @returns string value
 * @description Function returns User Patient Condition retriving from async storage using key
 */
export const getPatientCondition = async () => {
  try {
    // eslint-disable-next-line no-undef
    const data = localStorage.getItem(KEYS.userInfo);
    const value = JSON.parse(data);
    return value.patientCondition[0];
  } catch (e) {
    // saving error
    //put in analytics for example
  }
};
